import React from "react";
import {
  IconMessageCircle,
  IconRobot,
  IconPlugConnected,
  IconSchool,
  IconChartBar,
  IconCreditCard,
} from "@tabler/icons-react";

// ===============================================
// CONFIGURACAO DOS MENUS
// ===============================================

const MENU_ITEMS = [
  {
    icon: IconMessageCircle,
    name: "Atendimento",
    desc: "Central de conversas com seus clientes",
  },
  {
    icon: IconRobot,
    name: "Agentes",
    desc: "Criação e gestão dos seus agentes de IA",
  },
  {
    icon: IconPlugConnected,
    name: "Apps & Integrações",
    desc: "Conexão com WhatsApp e outros canais",
  },
  {
    icon: IconSchool,
    name: "Aprendizado",
    desc: "Treinamentos e aulas essenciais",
  },
  {
    icon: IconChartBar,
    name: "Gestão Comercial",
    desc: "CRM, agenda e base de clientes",
  },
  {
    icon: IconCreditCard,
    name: "Financeiro",
    desc: "Plano, faturamento e assinaturas",
  },
];

// ===============================================
// NAVIGATION STEP COMPONENT
// ===============================================

const NavigationStep = () => {
  return (
    <>
      <div className="onb-card__header">
        <h2 className="onb-card__title">Menu de Navegação</h2>
        <p className="onb-card__subtitle">
          Aqui estão as principais áreas da plataforma
        </p>
      </div>

      <div className="onb-card__body">
        <div className="onb-menu-list">
          {MENU_ITEMS.map((item, index) => (
            <div key={index} className="onb-menu-item">
              <div className="onb-menu-item__icon">
                <item.icon size={18} />
              </div>
              <div className="onb-menu-item__info">
                <span className="onb-menu-item__name">{item.name}</span>
                <span className="onb-menu-item__desc">{item.desc}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default NavigationStep;
